import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef, DialogService } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';
import { AdresseEntite } from 'src/app/entites/adresse';
import { EmplacementAdresseEntite } from 'src/app/entites/emplacement-adresse-entite';
import { EmplacementService } from 'src/app/services/emplacement-service';
import { RequeteAjouterEmplacementAdresse } from 'src/app/services/requetes/requete-ajouter-emplacement-adresse';
import { RechercheAdresseComponent } from 'src/app/controles/recherche-adresse.component';

@Component({
  selector: 'app-ajouter-adresse-emplacement',
  templateUrl: './ajouter-adresse-emplacement.component.html',
  providers: [MessageService, DialogService]
})
export class AjouterAdresseEmplacementComponent implements OnInit {
  
  emplacementId: number;
  nouvelleAdresse: AdresseEntite = null;
  enChargement: boolean = false;

  constructor(
    private config: DynamicDialogConfig,
    private ref: DynamicDialogRef,
    private emplacementService: EmplacementService,
    private messageService: MessageService,
    private dialogService: DialogService
  ) {
    this.emplacementId = this.config.data.emplacementId;
  }

  ngOnInit(): void {}

  /// <summary>
  /// Opens address search dialog for selecting an address
  /// </summary>
  rechercherAdresse(): void {
    this.dialogService.open(RechercheAdresseComponent, {
      header: 'Recherche une adresse',
      width: '50%'
    }).onClose.subscribe((adresse: AdresseEntite) => {
      if (adresse) {
        this.nouvelleAdresse = adresse;
      }
    });
  }

  /// <summary>
  /// Validates and submits the new address to the backend
  /// </summary>
  confirmer(): void {
    if (!this.nouvelleAdresse || !this.nouvelleAdresse.numero) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Attention',
        detail: 'Veuillez sélectionner une adresse valide'
      });
      return;
    }

    if (!this.nouvelleAdresse.nom || this.nouvelleAdresse.nom.trim() === '') {
      this.messageService.add({
        severity: 'warn',
        summary: 'Attention',
        detail: 'Veuillez entrer un nom pour cette adresse'
      });
      return;
    }

    this.enChargement = true;

    const requete: RequeteAjouterEmplacementAdresse = {
      adresse: this.nouvelleAdresse
    };

    this.emplacementService.AjouterAdresseEmplacement(this.emplacementId, requete).subscribe({
      next: (nouvelleAdresse: EmplacementAdresseEntite) => {
        this.enChargement = false;
        this.ref.close(nouvelleAdresse);
      },
      error: (error) => {
        this.enChargement = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: `Une erreur est survenue lors de l'ajout de l'adresse: ${error.message}`
        });
      }
    });
  }

  /// <summary>
  /// Cancels the dialog without adding an address
  /// </summary>
  annuler(): void {
    this.ref.close(null);
  }
}

